import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchLoanComponent } from './search-loan.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule, NavParams } from '@ionic/angular';
import { DirectivesModule } from '@shared-directives/directives.module';
import { TranslationModule } from '@app/app-translation.module';
import { PipesModule } from '@shared-pipes/pipes.module';
import { FormInputModule, FormLabelModule, FormSelectModule } from '@beego/ngx-form-components';

@NgModule({
	declarations: [SearchLoanComponent],
	exports: [SearchLoanComponent],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		IonicModule,
		TranslationModule,
		FormInputModule,
		FormLabelModule,
		DirectivesModule,
		PipesModule,
		FormSelectModule,
	],
	providers: [NavParams],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SearchLoanComponentModule {}
